var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#007AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9612 23.6356C23.6395 23.6356 25 22.2751 25 20.5969C25 18.9187 23.6395 17.5581 21.9612 17.5581H21.9442C21.9555 17.433 21.9612 17.3063 21.9612 17.1783C21.9612 14.8707 20.0905 13 17.783 13C15.4753 13 13.6046 14.8707 13.6046 17.1783C13.6046 17.1819 13.6047 17.1855 13.6047 17.1891C12.1185 17.4907 11 18.8046 11 20.3798C11 22.1779 12.4577 23.6356 14.2558 23.6356",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1629 23.6363V19.8379M18.1629 19.8379L19.6823 21.3573M18.1629 19.8379L16.6436 21.3573",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUploadIcon);
export default __webpack_public_path__ + "static/media/profile_upload_icon.97f495912e6d4338677e68bab54456a6.svg";
export { ForwardRef as ReactComponent };